<template>
    <z-basePage :title="title" :pop="true">
        <z-backForm :name="'back-ticket'" :align="true" :btns="sub.name | btnFlag" :btnText="Id | btnText" @save="saveSet" @cancel="backset">
            <!-- 罚单类型名称-->
            <div class="back-item">
                <div class="back-title">类型名称</div>
                <div class="back-wrap" :class="{text:systemFlag}">
                    <div v-show="systemFlag">{{ sub.name }}</div>
                    <el-input v-show="!systemFlag" rule="limit" v-arg="[2,15]" v-tar="sub.name" v-model="sub.name" placeholder="请输入类型名称"></el-input>
                </div>
            </div>
            <!-- 适用对象 -->
            <div class="back-item">
                <div class="back-title">适用对象</div>
                <div class="back-wrap" :class="{text:systemFlag}">
                    <div v-show="systemFlag">{{ sub.target | ticketTar}}</div>
                    <el-select v-show="!systemFlag" rule="noVal" v-tar="sub.target" v-model="sub.target" placeholder="请选择">
						<el-option v-for="item in targetArr" :key="item.val" :value="item.val" :label="item.label">
						</el-option>
					</el-select>
                    <!-- <el-input class="top-choose" rule="noVal" v-tar="sub.name" v-model="sub.name" placeholder="请输入快币名称"></el-input> -->
                </div>
            </div>
            <!-- 罚单金额 -->
            <div class="back-item">
                <div class="back-title">罚单金额</div>
                <div class="back-wrap text">
                    <div v-show="systemFlag && sub.name == '任务延期'">{{ sub.amount | ticket(sub.name) }}</div>
                    <div v-show="systemFlag && sub.name == '任务超期'">{{ sub.amount | ticket(sub.name) }}</div>
                    <el-input v-if="systemFlag && sub.name == '任务滞留'" class="long" rule="noVal number positive" v-tar="sub.amount" v-model="sub.amount" placeholder="请输入罚款数值">
                        <template slot="prepend">任务金额</template>
                        <template slot="append">{{ "%" }}</template>
                    </el-input>

                    <el-input v-if="!systemFlag || sub.name != '任务延期' && sub.name != '任务超期' && sub.name != '任务滞留'"  rule="noVal number positive" v-tar="sub.amount" v-model="sub.amount" placeholder="请输入罚款数值">
                        <template slot="append">{{ ticket_curr.currency_name }}</template>
                    </el-input>
                </div>
            </div>
            <!-- 罚单说明 -->
            <div class="back-item area">
                <div class="back-title">罚单说明</div>
                <div class="back-wrap" :class="{text:systemFlag}">
                    <div class="descript" v-show="systemFlag">{{ sub.description }}</div>
                    <textarea v-show="!systemFlag" rule="reason describe_limit" v-arg="'罚单说明'" v-tar="sub.description" v-model="sub.description" placeholder="请输入罚单说明"></textarea>
                </div>
            </div>


        </z-backForm>

    </z-basePage>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        data(){
            return {
                systemFlag:false,   //是否是系统罚单
                sub:{
                    name:'',    //type name 
                    target:30,  //适用对象
                    amount:"",  //罚币金额
                    description:"",  //描述
                },
                targetArr:[
                    // {
                    //     val:10,
                    //     label:"BU",
                    // },
                    // {
                    //     val:20,
                    //     label:"合伙人",
                    // },
                    {
                        val:30,
                        label:"职员",
                    }
                ],
                currencyArr:[
                    {
                        val:1,
                        label:"罚币",
                    }
                ]

            }
        },
        computed:{
            ...mapGetters(['ticket_curr']),
            Id(){
                return this.$crypto.decrypt(this.$route.params.id);
            },
            title(){
                return this.Id == 0?'新建罚单':"编辑罚单";
            },
        },
        filters:{
            btnFlag(name){  //功能按钮判断器
                if( name != '任务延期' && name != '任务超期'){
                    return true;
                }
                return false;
            },
            btnText(id){
                return id == 0?"创建":"保存";
            }
        },
        created(){
            if( this.Id != 0 ){
                this.getData();
            }
        },
        beforeRouteLeave(to,from,next){  //离开页面之前
			let res = this.$form.leave({name:'back-ticket',path:to.path});
			next(res);
		},
        methods:{
            getData(){
                let url = `api/admin/cfg_ticket/${this.Id}`;
                this.$http.get(url).then(res=>{
                    if(res.status == 200){
                        let data = res.res_data;
                        let sub = this.sub;
                        this.systemFlag = data.ticketType == 10;
    
                        sub.name = data.ticketName;    //type name 
                        sub.target = data.ticketTarget;  //适用对象
                        sub.amount = data.ticketAmount;  //罚币金额
                        sub.amount = data.ticketAmount;
                        sub.description = data.ticketDescription;  //描述                    
                        this.$form.init('back-ticket');
                    }
                });
               
            },
            saveSet(){  //保存
                this.$func.loading(true);
                if(this.Id != 0){  //修改 
                    if(this.systemFlag){  //系统罚单
                        let url = `api/admin/cfg_ticket/system/${this.Id}`;
                        let obj = {
                            ticket_amount:this.sub.amount,
                        }
                        this.$http.put(url,obj).then(res=>{
                            if(res.status == 200){
                                this.successTip("保存成功");
                                this.$router.push({
                                    name:"back-setting-ticket",
                                    query:{
                                        tab:0,
                                    }
                                });
                            }
                            this.$func.loading(false);
                        }).catch(err=>{
                            this.$func.loading(false);
                        })
                    }else{   //人工罚单
                        let url = `api/admin/cfg_ticket/personal/${this.Id}`;
                        let obj = {
                            ticket_name:this.sub.name,
                            ticket_target:this.sub.target,
                            ticket_amount:this.sub.amount,
                            ticket_desc:this.sub.description,
                        }
                        this.$http.put(url,obj).then(res=>{
                            if(res.status == 200){
                                this.successTip("保存成功");
                                this.$router.push({
                                    name:"back-setting-ticket",
                                    query:{
                                        tab:1,
                                    }
                                });
                                this.getData();
                            }
                            this.$func.loading(false);
                        }).catch(err=>{
                            this.$func.loading(false);
                        })
                    }
                }else{   //新建
                    let url = `api/admin/cfg_ticket/personal`;  
                    let obj = {
                        ticket_name:this.sub.name,
                        ticket_target:this.sub.target,
                        ticket_amount:this.sub.amount,
                        ticket_desc:this.sub.description,
                    }
                    this.$http.post(url,obj).then(res=>{
                        if(res.status == 200){
                            this.successTip("新建成功");
                            this.$router.push({
                                name:"back-setting-ticket",
                                query:{
                                    tab:1,
                                }
                            });
                        }
                        this.$func.loading(false);
                    }).catch(err=>{
                        this.$func.loading(false);
                    })
                }
            },
            backset(dataArr){  //取消
                let sub = this.sub;
                [
                    sub.name,
                    sub.target,
                    sub.amount,
                    sub.description,
                ] = dataArr;
            },
        }

    }
</script>

<style lang="less" scoped>
    .long{
        width: 200px !important;
    }
    .descript{
        width:400px;
    }
</style>





// WEBPACK FOOTER //
// page-ticket-add.vue?0c618242